import React from "react";
import './Grid.scss';

// setConfiguration({ maxScreenClass: 'xl' });

const Grid = () => {
    return (
        <>
           
                    {/* ----------gfgfgf---------- */}

                    <div class="containerbox">
    <h1>Front End Developers</h1>
    <div class="row">
        <div class="col-md-3 col-sm-6 ">
            <div class="service-box">
                <div class="service-icon yellow">
                    <div class="front-content">
                        <i class="fa fa-trophy"></i>
                        <h3>Angular</h3>
                    </div>
                </div>
                <div class="service-content">
                    <h3>Angular Developers</h3>
                    <p>Angular developers work on the client side of the software, which is the core activity of the developer. They can build a full-fledged User Interface service for websites and web applications.</p>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-sm-6 ">
            <div class="service-box">
                <div class="service-icon orange">
                    <div class="front-content">
                        <i class="fa fa-anchor"></i>
                        <h3>React</h3>
                    </div>
                </div>
                <div class="service-content">
                    <h3>React Developers</h3>
                    <p>A React developer designs and creates JavaScript-based applications for web or mobile environments. They typically specialize in front-end development. React is an open-source JavaScript library.</p>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-sm-6">
            <div class="service-box ">
                <div class="service-icon red">
                    <div class="front-content">
                        <i class="fa fa-trophy"></i>
                        <h3>Testers</h3>
                    </div>
                </div>
                <div class="service-content">
                    <h3>QA Automation and Menual Automation</h3>
                    <p>A QA engineer creates tests that identify issues with software before a product launch. Manual testers design test cases or scenarios with 100 percent test coverage, and execute them one by one before verifying the results.</p>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-sm-6">
            <div class="service-box">
                <div class="service-icon grey">
                    <div class="front-content">
                        <i class="fa fa-paper-plane-o"></i>
                        <h3>Javascript Developers</h3>
                    </div>
                </div>
                <div class="service-content">
                    <h3>MERN AND MEAN Developers</h3>
                    <p>A MERN stack developer is an expert in MongoDB, Express, React and Node. MEAN stack development refers to the development process that falls within these particular set of technologies MongoDB, Expressjs, AngularJs, NodeJS. </p>
                </div>
            </div>
        </div>
    </div>
    <h1>Back End Developer</h1>
    <div class="row">
        <div class="col-md-3 col-sm-6 ">
            <div class="service-box">
                <div class="service-icon yellow">
                    <div class="front-content">
                        <i class="fa fa-trophy"></i>
                        <h3>Python</h3>
                    </div>
                </div>
                <div class="service-content">
                    <h3>Pyhthon</h3>
                    <p>Python developers design, code, and deploy development projects in the Python language. 
                    They also work on debugging those same projects to ensure they function as intended. As a python developer, 
                    you'll work closely with other teams, including data collection and analytics, to help answer questions and provide insight.</p>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-sm-6 ">
            <div class="service-box">
                <div class="service-icon orange">
                    <div class="front-content">
                        <i class="fa fa-anchor"></i>
                        <h3>Java</h3>
                    </div>
                </div>
                <div class="service-content">
                    <h3>Java Developer</h3>
                    <p>A Java Developer is a programmer who designs, develops, and manages Java-based applications and software. With most large organizations using Java to implement software systems and backend services, 
                    a Java developer is one of the most sought-after jobs today</p>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-sm-6">
            <div class="service-box ">
                <div class="service-icon red">
                    <div class="front-content">
                        <i class="fa fa-trophy"></i>
                        <h3>Dotnet Developers</h3>
                    </div>
                </div>
                <div class="service-content">
                    <h3>Dotnet Developer</h3>
                    <p>DOTNET developer is a software engineer who builds the software using Microsoft's . NET technologies. He is responsible for the design, implementation and development of the software products according to technical needs.</p>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-sm-6">
            <div class="service-box">
                <div class="service-icon grey">
                    <div class="front-content">
                        <i class="fa fa-paper-plane-o"></i>
                        <h3>And All</h3>
                    </div>
                </div>
                <div class="service-content">
                    <h3>And All</h3>
                    <p>All developers and testers are available </p>
                </div>
            </div>
        </div>
    </div>
</div>

        </>
    );

}


export default Grid;